import { ArrowLeft } from 'react-feather';
import { hapticsImpactLight } from '../../../utils/haptics';
import OraLogo from '../../Global/OraLogo';
import Tooltip from '@mui/material/Tooltip';
import { useEffect, useRef } from 'react';
import useWindowWidth from '../../../hooks/useWindowWidth';

interface FrameProps {
  classes?: string;
  frameId: number;
  currentOnboardingFrameId: number;
  currentFrameIndex: number;
  setCurrentFrameIndex: (index: number) => void;
  frameSequence: number[];
  showNext: boolean;
  showBack: boolean;
  advanceAllowed: boolean;
  advanceTooltip?: string;
  hideStepIndicator?: boolean;
  onContinue?: () => void;
}

const Frame: React.FC<FrameProps & { children: React.ReactNode }> = ({
  classes,
  frameId,
  currentOnboardingFrameId,
  currentFrameIndex,
  setCurrentFrameIndex,
  frameSequence,
  showNext,
  showBack,
  advanceAllowed,
  advanceTooltip,
  hideStepIndicator,
  onContinue,
  children,
}) => {
  const frameRef = useRef<HTMLDivElement>(null);
  const windowWidth = useWindowWidth();

  useEffect(() => {
    if (currentOnboardingFrameId === frameId && frameRef.current) {
      // Add a small delay to ensure the frame is mounted before starting the animation
      setTimeout(() => {
        frameRef.current?.classList.add('show');
      }, 50);
    } else if (frameRef.current) {
      frameRef.current.classList.remove('show');
    }
  }, [currentOnboardingFrameId, frameId]);

  return (
    <div
      ref={frameRef}
      className={`onboarding_frame ${classes ? classes : ''}`}
      style={
        currentOnboardingFrameId === frameId
          ? { display: 'flex' }
          : { display: 'none' }
      }
    >
      <div className="onboarding_frame_header">
        <OraLogo />
        {/* Don't show on loader */}
        {currentOnboardingFrameId !== 100 && !hideStepIndicator && (
          <div className="step-indicator">
            {frameSequence.slice(0, -1).map((_, frameIndex) => (
              <div
                key={frameIndex}
                className={`step ${currentFrameIndex === frameIndex ? 'active' : ''}`}
              ></div>
            ))}
          </div>
        )}
      </div>
      <div className={`onboarding_frame_content`}>
        <div className="onboarding_frame_content_body">{children}</div>
        <div
          className="onboarding_frame_content_actions"
          style={
            showBack || showNext
              ? windowWidth > 900
                ? { padding: '1.5rem 3rem' }
                : { padding: '1.5rem' }
              : {}
          }
        >
          {showBack && (
            <button
              className="button button--prev"
              onClick={() => {
                setCurrentFrameIndex(currentFrameIndex - 1);
                hapticsImpactLight();
              }}
            >
              <ArrowLeft />
            </button>
          )}
          {showNext && (
            <Tooltip
              title={!advanceAllowed && advanceTooltip ? advanceTooltip : ''}
            >
              <span>
                <button
                  className="button button--glass button--next"
                  onClick={() => {
                    setCurrentFrameIndex(currentFrameIndex + 1);
                    onContinue?.();
                    hapticsImpactLight();
                  }}
                  disabled={!advanceAllowed}
                >
                  {currentFrameIndex === frameSequence.length - 2
                    ? 'Finish'
                    : 'Continue'}
                </button>
              </span>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
};

export default Frame;
